export default {
	getSubscriberConfig(state) {
		return state.SubscriberConfig;
	}
};
